import { Inject, Injectable } from '@angular/core';
import { COMMONS_ENV, ObservableService } from '@damofire/data-angular-commons';
import { Dto, Query, SearchResult } from '@damofire/data-commons';
import { LayoutTextSegment, Warehouse, WarehouseOutlineSegment } from './warehouse.dto';

@Injectable()
export abstract class WarehouseService extends ObservableService<Warehouse> {
  protected outlines: WarehouseOutlineSegment[] = [];
  protected texts: LayoutTextSegment[] = [];
  protected divisionId: string;

  protected constructor(@Inject(COMMONS_ENV) protected readonly environment: any) {
    super();
  }

  abstract get(id: string): Promise<Warehouse>;
  abstract search(query: Query): Promise<SearchResult<Warehouse>>;
  abstract getOfflineWarehouses(): Promise<Dto<string>[]>;

  abstract reloadOutlines(): Promise<void>;
  abstract reloadLayoutTexts(): Promise<void>;

  async resolveOutline(divisionId: string): Promise<WarehouseOutlineSegment[]> {
    if (divisionId !== this.divisionId || this.outlines.length === 0) {
      this.divisionId = divisionId;
      this.texts = [];
      await this.reloadOutlines();
    }
    return this.outlines;
  }

  async resolveLayoutTexts(divisionId: string): Promise<LayoutTextSegment[]> {
    if (divisionId !== this.divisionId || this.texts.length === 0) {
      this.divisionId = divisionId;
      this.outlines = [];
      await this.reloadLayoutTexts();
    }
    return this.texts;
  }

  invalidateResolvedLayout(): void {
    this.outlines = [];
    this.texts = [];
    this.divisionId = null;
  }
}
